import { objectToQueryString } from './objectToQueryString';

const toUrl = (query) => {
  const {
    protocol, hash, host, pathname, search,
  } = window.location;

  const params = new URLSearchParams(search);
  const preview = params.get('x-craft-preview');
  const token = params.get('token');

  let url = `${protocol}//${host}${pathname}`;
  const queryParts = [];

  if (query) queryParts.push(query);
  if (preview && token) queryParts.push(`x-craft-preview=${preview}&token=${token}`);

  if (queryParts.length) {
    url += `?${queryParts.join('&')}`;
  }

  return `${url}${hash}`;
};

export function updateLocationQuery(data = {}) {
  if (!window.history.pushState) {
    return;
  }

  // Clone provided data so we don't mutate callers' objects
  const mergedData = { ...data };

  // Preserve existing UTM parameters
  const existingParams = new URLSearchParams(window.location.search);
  existingParams.forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm_') && !Object.prototype.hasOwnProperty.call(mergedData, key)) {
      mergedData[key] = value;
    }
  });

  const query = objectToQueryString(mergedData);
  const url = toUrl(query);

  const currentUrl = window.location.href;

  // Avoid interfering with site-search page URLs
  if (!currentUrl.includes('search?q=')) {
    window.history.pushState({ path: url }, '', url);
  }
}
